import React from "react";
import { PenTool, Layers, ShieldCheck } from "lucide-react";
import Reveal from "../Reveal";
import { services, studio } from "../../mock";

const icons = { PenTool, Layers, ShieldCheck };

const ServicesSection = () => {
  return (
    <section className="relative overflow-hidden py-24 lg:py-32" id="services" data-testid="services-section">
      {/* Video background */}
      <div className="absolute inset-0">
        <video
          className="h-full w-full object-cover opacity-40 grayscale"
          autoPlay
          muted
          loop
          playsInline
          poster={studio.images.servicesPoster}
          aria-hidden="true"
        >
          <source src={studio.video.services} type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-background/70" />
        <div className="absolute inset-0 bg-gradient-to-b from-background via-transparent to-background" />
      </div>

      <div className="container-x relative">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="eyebrow">What we do</p>
            </Reveal>
            <Reveal delay={80}>
              <h2 className="display mt-6 text-[clamp(3.5rem,8vw,8rem)] uppercase leading-[0.85] tracking-wide">
                Our
                <br />
                Services
              </h2>
            </Reveal>
            <Reveal delay={160}>
              <p className="mt-8 max-w-md text-base leading-relaxed text-foreground/80 md:text-lg">{services.intro}</p>
            </Reveal>
          </div>

          <div className="grid gap-px bg-border/60 lg:col-span-7 lg:mt-6">
            {services.items.map((item, i) => {
              const Icon = icons[item.icon] || PenTool;
              return (
                <Reveal
                  key={item.id}
                  delay={i * 100}
                  className="group relative flex gap-6 bg-background/80 p-7 backdrop-blur-sm transition-colors duration-500 hover:bg-card md:p-9"
                  data-testid={`service-card-${item.id}`}
                >
                  <span className="display text-2xl text-muted-foreground/60">{String(i + 1).padStart(2, "0")}</span>
                  <div className="flex-1">
                    <div className="flex items-center justify-between gap-4">
                      <h3 className="display text-3xl uppercase tracking-wide md:text-4xl">{item.title}</h3>
                      <span className="flex h-11 w-11 shrink-0 items-center justify-center border border-border text-primary transition-colors duration-500 group-hover:border-primary group-hover:bg-primary group-hover:text-primary-foreground">
                        <Icon className="h-5 w-5" />
                      </span>
                    </div>
                    <p className="mt-3 max-w-lg text-sm leading-relaxed text-muted-foreground md:text-base">{item.body}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
